import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=59217ea1&scoped=true"
import script from "./SupportForm.vue?vue&type=script&lang=js"
export * from "./SupportForm.vue?vue&type=script&lang=js"
import style0 from "./SupportForm.vue?vue&type=style&index=0&id=59217ea1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59217ea1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59217ea1')) {
      api.createRecord('59217ea1', component.options)
    } else {
      api.reload('59217ea1', component.options)
    }
    module.hot.accept("./SupportForm.vue?vue&type=template&id=59217ea1&scoped=true", function () {
      api.rerender('59217ea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/modules/SupportForm.vue"
export default component.exports